var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4"},[_c('label',{attrs:{"for":""}},[_vm._v("\n    "+_vm._s(_vm.$t('PROFILE_SETTINGS.FORM.SYSTEM_ALERTS.EXTRA_SETTINGS.EMAIL.LABEL'))+"\n    "),_c('input',{attrs:{"type":"text","placeholder":_vm.$t(
          'PROFILE_SETTINGS.FORM.SYSTEM_ALERTS.EXTRA_SETTINGS.EMAIL.PLACEHOLDER'
        )},domProps:{"value":_vm.value},on:{"blur":function($event){return _vm.$emit('input', $event.target.value)}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }